const routes = [
  { label: 'Work', path: '/projects' },
  { label: 'Experience', path: '/resume' },
  { label: 'Notes', path: '/notes' },
  { label: 'Guides', path: '/guides' },
  { label: 'Research', path: '/research' },
  { label: 'Investing', path: '/investing' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export default routes;
